export default "/select-item.3b079488762e7ee8d2653e94c963a84d.svg";